export const filterInitialState = {
    tags: {
        label: 'Tag',
        value: []
    },
    seriale: {
        label: 'Seriale',
        isSensitive: true,
        value: ""
    },
    numeroDiTelefono: {
        label: 'Numero di telefono',
        isSensitive: true,
        value: ""
    },
    piano: {
        label: "Piano Commerciale",
        value: ""
    }
}

export const sortingCriteria =
    [
        {text: "Numero di telefono", value: "msisdn"},
        {text: "Seriale", value: "iccid"},
        {text: "Piano", value: "piano"}
    ]

export const filterRadioButtons =
    [
        {text: "Numero di telefono", value: "numeroDiTelefono"},
        {text: "Numero seriale", value: "seriale"},
        {text: "Tag", value: "tags"}
    ]

export const headCells = [
    {id: 'Numero di telefono', label: 'Numero di telefono', width: "20%"},
    {id: 'Seriale', label: 'Seriale', width: "20%"},
    {id: 'Piano commerciale', label: "Piano commerciale", width: "15%"},
    {id: 'tags', label: 'Tag', width: "30%"},
    {id: 'wrench', label: '', width: "15%"}
]
